import Strings from "../../config/Strings";

export const ADDRESS_FIELDS = ["country", "firstName", "lastName", "street", "houseNumber", "zip", "city"];

const POSTAL_CODE_DIGITS = {DE: 5, AT: 4, CH: 4};
//e.g. 12, 12a, 12 a, 4-6, 5/2/14
const HOUSE_NUMBER = /^\d+\s?[a-zA-Z]?(\s?[-/]\s?\d+\s?[a-zA-Z]?)*$/;
//a street with a house number at its end, e.g. "Musterstraße 12a"
const STREET_WITH_HOUSE_NUMBER = /^(.*\D)\s+(\d+\s?[a-zA-Z]?(\s?[-/]\s?\d+\s?[a-zA-Z]?)*)$/;
const DIGIT = /\d/;

/**
 * Checks one field of an address entered by the customer.
 * Returns the error message or null if the field is valid.
 */
export function validateAddressField(field, address) {
    const value = (address[field] || "").trim();
    if (!value) {
        return Strings.PURCHASE_FORM_FIELD_REQUIRED;
    }
    switch (field) {
        //catches e.g. the street entered into the name field
        case "firstName":
        case "lastName":
            return DIGIT.test(value) ? Strings.PURCHASE_ADDRESS_ERROR_NAME : null;
        case "houseNumber":
            return HOUSE_NUMBER.test(value) ? null : Strings.PURCHASE_ADDRESS_ERROR_HOUSE_NO;
        case "zip": {
            const digits = POSTAL_CODE_DIGITS[address.country];
            return digits && !new RegExp("^\\d{" + digits + "}$").test(value)
                ? Strings.PURCHASE_ADDRESS_ERROR_POSTAL_CODE.replace("{0}", digits)
                : null;
        }
        case "city":
            return DIGIT.test(value) ? Strings.PURCHASE_ADDRESS_ERROR_CITY : null;
        default:
            return null;
    }
}

/**
 * Checks all fields of an address, returns an object with the error message (or null) per field.
 */
export function validateAddress(address) {
    return Object.fromEntries(ADDRESS_FIELDS.map(field => [field, validateAddressField(field, address)]));
}

export function hasErrors(errors) {
    return Object.values(errors).some(error => error != null);
}

/**
 * Moves a house number entered at the end of the street into the empty house number field.
 * Returns the changed fields or null if there is nothing to move.
 */
export function moveHouseNumberFromStreet(address) {
    if ((address.houseNumber || "").trim()) {
        return null;
    }
    const match = (address.street || "").trim().match(STREET_WITH_HOUSE_NUMBER);
    return match ? {street: match[1].trim(), houseNumber: match[2]} : null;
}

/**
 * The address in the format of the address validation of the purchase-service.
 */
export function toValidationRequest(address) {
    return {
        street: address.street.trim(),
        houseNumber: address.houseNumber.trim(),
        postalCode: address.zip.trim(),
        city: address.city.trim(),
        country: address.country,
    };
}

/**
 * A suggested address of the address validation as changes of the entered address.
 */
export function fromValidationSuggestion(suggestedAddress) {
    return {
        street: suggestedAddress.street,
        houseNumber: suggestedAddress.houseNumber,
        zip: suggestedAddress.postalCode,
        city: suggestedAddress.city,
        country: suggestedAddress.country,
    };
}

export function formatStreetLine(address) {
    return (address.street || "") + " " + (address.houseNumber || "");
}

export function formatCityLine(address) {
    return (address.zip || "") + " " + (address.city || "");
}
